import { render, staticRenderFns } from "./VwaType.vue?vue&type=template&id=6e073768&scoped=true&"
import script from "./VwaType.vue?vue&type=script&lang=ts&"
export * from "./VwaType.vue?vue&type=script&lang=ts&"
import style0 from "./VwaType.vue?vue&type=style&index=0&id=6e073768&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e073768",
  null
  
)

export default component.exports